import { createSelector } from 'reselect';

const totsAvisos = (state) => {
    if (!state.avis.visualitzacio.avisos.tots) {
        return [];
    }

    return state.avis.visualitzacio.avisos.tots;
};

const idsFiltratsPelMapa = (state) => {
    if (!state.avis.visualitzacio.avisos.idsFiltratsPelMapa) {
        return [];
    }

    return state.avis.visualitzacio.avisos.idsFiltratsPelMapa;
};

/**
 * Recupera els avisos amb els ids que hi hagin a idsFiltratsPelMapa.
 * @param totsAvisos
 * @param idsFiltratsPelMapa
 * @returns {*}
 */
const obtenirLlistatAvisosFiltratsPelMapa = (totsAvisos, idsFiltratsPelMapa) => {
    return totsAvisos
        // De tots els avisos, es filtren només els que hi hagin a idsFiltratsPelMapa
        .filter( (avis) => {
            const { id } = avis;
            return idsFiltratsPelMapa.includes(id);
        });
};

const selector = createSelector(
    totsAvisos,
    idsFiltratsPelMapa,
    obtenirLlistatAvisosFiltratsPelMapa
);

export default selector;



// WEBPACK FOOTER //
// ./src/selectors/selector_avis_llista.js